module.exports = __webpack_public_path__ + "static/media/AllBrands.4faf5e47.png";